module.exports = __webpack_public_path__ + "static/media/elephant-transparent.24c6c898.png";